import { useCallback, useEffect, useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";
import profileImg from "../../assets/images/profile.png";
import Editor from "react-simple-wysiwyg";
import LeaveHistoryService from "../../services/leaveHistory.service";
import AuthService from "../../services/auth.service";
import moment from "moment";

const RevokeRequest = ({
  leaveDays,
  selectedRowData,
  setSuccess,
  fetchData,
  revokeModal,
  setRevokeModal,
  setHeading,
}) => {
  const { approveModal, getNameInitials } = useStateContext();

  const [html, setHtml] = useState("");

  const user = AuthService.getCurrentUser();

  const [approvedDayslist, setApprovedDayslist] = useState([]);

  const [leaveInfo, setLeaveInfo] = useState({});

  const checkLeaveInfo = useCallback(() => {
    const payload = {
      empId: selectedRowData.emp_id,
    };
    // console.log("Payload for Leave Info:", payload);
    if (payload.empId) {
      LeaveHistoryService.getEmpInfo(payload)
        .then((resp) => {
          if (resp.data) {
            // console.log("Leave Info:", resp.data);
            setLeaveInfo(resp.data[0]);
          }
        })
        .catch((e) => console.log(e));
    } else {
      setLeaveInfo({});
    }
  }, [selectedRowData]);

  useEffect(() => {
    checkLeaveInfo();
  }, [checkLeaveInfo]);

  const fetchEmpLeaveDays = useCallback(() => {
    const payload = {
      reqid: selectedRowData.rid,
      empid: selectedRowData.emp_id,
    };

    if (revokeModal) {
      LeaveHistoryService.getEmpLeaveDayslist(payload)
        .then((resp) => {
          // console.log("Emp Leave Days List Response:", resp.data);
          const data = resp.data.map((item) => ({
            ...item,
            ispaid: item.ispaidval,
          }));
          setApprovedDayslist(data);
        })
        .catch((e) => console.log(e));
    }
  }, [revokeModal]);

  useEffect(() => {
    fetchEmpLeaveDays();
  }, [fetchEmpLeaveDays]);

  const setIsPaid = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.lDate === date
          ? { ...item, ispaid: item.ispaid === "1" ? "0" : "1" }
          : item,
      ),
    );
  };

  const setIsGoodwill = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.lDate === date
          ? { ...item, isGoodWill: item.isGoodWill === "1" ? "0" : "1" }
          : item,
      ),
    );
  };

  const setIsApproved = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.lDate === date
          ? {
              ...item,
              isApproved: item.isApproved === "1" ? "0" : "1",
              ispaid: item.isApproved === "1" ? "0" : "1",
            }
          : item,
      ),
    );
  };

  // console.log("approvedDayslist", approvedDayslist);

  const onChange = (e) => {
    setHtml(e.target.value);
  };

  // Calculate counts
  const isGoodWillCount = approvedDayslist
    .filter((item) => item.isGoodWill === "1")
    .reduce((sum, item) => sum + (item.workday === "0.5" ? 0.5 : 1), 0);
  const isApprovedCount = approvedDayslist
    .filter((item) => item.isApproved === "1")
    .reduce((sum, item) => sum + (item.workday === "0.5" ? 0.5 : 1), 0);

  const approveLeaveRequest = () => {
    // Ensure at least one day is approved before proceeding
    const hasApprovedDay = approvedDayslist.some(
      (item) => item.datetype === "Weekday" && item.isApproved === "1",
    );

    if (!hasApprovedDay) {
      // lightweight user feedback and abort
      window.alert("Please approve at least one day before proceeding.");
      return;
    }
    const payload = {
      rid: selectedRowData && selectedRowData.rid,
      emp_id: selectedRowData && selectedRowData.emp_id,
      roleid: user && user.role,
      isapproved: "1",
      approvedBy: user && user.empid,
      approvedDays: isApprovedCount.toString(),
      isgoodwill: isGoodWillCount.toString(),
      isPartialApproved:
        isApprovedCount < selectedRowData.leavedays ? "1" : "0",
      isprobation: selectedRowData && selectedRowData.isProbation,
      actionComment: html,
      approvedDayslist: approvedDayslist
        .filter((item) => item.datetype === "Weekday")
        .map((item) => ({
          date: moment(item.lDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
          ishaifDay: item.ishaifDay,
          ispaid: item.ispaid,
          isGoodWill: item.isGoodWill,
          isApproved: item.isApproved,
        })),
    };

    // console.log(payload);

    LeaveHistoryService.empLeaveApproveProcess(payload)
      .then((resp) => {
        if (resp.data) {
          setSuccess(true);
          setHeading("Leave Request Approved Succesfully");
          fetchData();
          setRevokeModal(false);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${
          revokeModal ? "sortByModal visible" : "sortByModal hidden"
        }`}
      >
        <div className="flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Revoke Approved Leave Dates</span>
            </div>

            <div className="leaveModalHeading">
              <div className="row">
                <div className="col-lg-6">
                  <div className="left-flex">
                    <div className="profile">
                      {leaveInfo && leaveInfo.profile ? (
                        <img src={profileImg} width={40} alt="profileImg" />
                      ) : (
                        <>
                          <div className="circle">
                            <span>{getNameInitials(leaveInfo && leaveInfo.name)}</span>
                          </div>
                        </>
                      )}
                      <div className="profile-info">
                        <span className="name">
                          {leaveInfo && leaveInfo.name}
                        </span>
                        <span className="desig">
                          {leaveInfo && leaveInfo.designation}
                        </span>
                      </div>
                    </div>
                    <div className="csort">
                      <div className="d-flex flex-column">
                        <label htmlFor="leaveType" className="form-label">
                          Duration - {selectedRowData.leavedays} Days
                        </label>
                        {user.role === "1" && (
                          <label htmlFor="leaveType" className="form-label">
                            Approved Leave Days by RM -{" "}
                            {selectedRowData.approvedDays} Days
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  {leaveInfo && leaveInfo.isprobationsts === "0" ? (
                    <>
                      {" "}
                      <div className="balance">
                        <div className="left">
                          <span>Balance</span>
                        </div>
                        <div className="right">
                          <div className="flex">
                            <span>Quarterly:</span>
                            <span className="count">
                              {leaveInfo.queterlyBalanceLeave}
                            </span>
                          </div>
                          <div className="flex">
                            <span>Yearly:</span>
                            <span className="count">
                              {leaveInfo.yearlyBalanceLeave}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Half Day</th>
                  {user.role === "1" ? (
                    <>
                      {leaveInfo && leaveInfo.isprobationsts === "0" && (
                        <th>Paid</th>
                      )}
                      <th>Goodwill</th>
                    </>
                  ) : null}
                  <th>Approved</th>
                  {user.role === "1" && <th>Confirmed</th>}
                  {/* {user.role === "1" && approvalStatus === "Approved" && (
                    <th>Revoke</th>
                  )} */}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(approvedDayslist)
                  ? approvedDayslist.map((item) => {
                      return (
                        <tr key={item.lDate}>
                          <th>{item.lDate.split(" ")[0]}</th>
                          {item.datetype === "Weekday" ? (
                            <>
                              <td>{item.ishalfday === "1" ? "Yes" : "No"}</td>
                              {user.role === "1" ? (
                                <>
                                  {leaveInfo &&
                                    leaveInfo.isprobationsts === "0" && (
                                      <>
                                        <td>
                                          <input
                                            type="checkbox"
                                            onChange={() =>
                                              setIsPaid(item.lDate)
                                            }
                                            checked={item.ispaid === "1"}
                                          />
                                        </td>
                                      </>
                                    )}

                                  <td>
                                    <input
                                      type="checkbox"
                                      onChange={() => setIsGoodwill(item.lDate)}
                                      checked={item.isGoodWill === "1"}
                                    />
                                  </td>
                                </>
                              ) : null}

                              <td>
                                <input
                                  type="checkbox"
                                  onChange={() => setIsApproved(item.lDate)}
                                  checked={item.isApproved === "1"}
                                />
                              </td>
                            </>
                          ) : item.datetype === "Holiday" ? (
                            <th colSpan={4} style={{ textAlign: "center" }}>
                              {item.datetype}
                            </th>
                          ) : item.datetype === "Weekend" ? (
                            <th colSpan={4} style={{ textAlign: "center" }}>
                              {item.datetype}
                            </th>
                          ) : null}
                        </tr>
                      );
                    })
                  : null}
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th></th>
                  {user.role === "1" ? (
                    <>
                      {leaveInfo && leaveInfo.isprobationsts === "0" && (
                        <th></th>
                      )}
                      <th>{isGoodWillCount}</th>
                    </>
                  ) : null}
                  <th>{isApprovedCount}</th>
                </tr>
              </tfoot>
            </table>

            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Remark
              </label>
              <Editor value={html} onChange={onChange} />
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-approve" onClick={approveLeaveRequest}>
              Edit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RevokeRequest;
